import config from '@/config'

const celloResourceUrl = `${config.resourceHost}cello`

export default {
  endpoints: {
    baseUrl: celloResourceUrl,
    getToken: `${celloResourceUrl}/token`,
  },
}
